import { render } from "./ConversationThread.vue?vue&type=template&id=2734b604"
import script from "./ConversationThread.vue?vue&type=script&lang=js"
export * from "./ConversationThread.vue?vue&type=script&lang=js"
script.render = render

export default script